export const hasVerticalScroll = (element) => {
    return element.scrollHeight > element.clientHeight;
};
export const hasHorizontalScroll = (element) => {
    return element.scrollWidth > element.clientWidth;
};
export const hasScroll = (element) => {
    return hasVerticalScroll(element) || hasHorizontalScroll(element);
};
//# sourceMappingURL=hasScroll.js.map